// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Z6uSw","small":"v6E4R","container":"acMPN","orange":"oBeC5","purple":"JSdiF","deepPurple":"AEbMt","red":"V-emV","green":"FWm5I","yellow":"_3TPZc","label":"TSb1S"};